import { render, staticRenderFns } from "./GameStatusAndPopover.vue?vue&type=template&id=751f720d&scoped=true"
import script from "./GameStatusAndPopover.vue?vue&type=script&lang=js"
export * from "./GameStatusAndPopover.vue?vue&type=script&lang=js"
import style0 from "./GameStatusAndPopover.vue?vue&type=style&index=0&id=751f720d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751f720d",
  null
  
)

export default component.exports